import React, { Component } from 'react';
import { Form } from 'react-final-form';
import { ERRORSTYLE } from "../util/constants";
import DebouncingValidatingField from './debounceField';
import Styles from '../Styles.js';
import { GlobalContext } from '../global-context.js';

export default class Search extends Component {
  static contextType = GlobalContext;

  validateUser = async (value) => {
    let user_error = undefined;

    if (!value) {
        return user_error;
    }

    await fetch(`/api/person/${value}`)
        .then(res => {
            if (res.ok === false) {
              user_error = "User not found";
            }
        })
        .catch((error) => {
          user_error = "User not found";
        });
    return user_error;
  }

  searchUser = async (value) => {
    const { updateUserQuery } = this.context;
    const { eppn } = value;
    let user_error = undefined;

    let res = await fetch(`/api/person/${eppn}`);
    if (res && res.ok) {
      let person = await res.json();
      updateUserQuery(person);
    }
    else {
      user_error = "Server error";
    }
    return user_error;
  }

  clearSearch = () => {
    const { updateUserQuery } = this.context;
    updateUserQuery(null);
  }

  render() {
    return (
    <Styles>
        <div style={{margin: "25px 0", display: "flex", alignItems: "center"}}>
            <label style={{height: "50px"}}>
              <h3 style={{margin: "0 25px 0 0"}}>Search Users</h3>
            </label>
            <Form
              onSubmit={this.searchUser}
              render={({
                handleSubmit,
                form,
                reset,
                submitting,
                pristine,
                values }) => (
                  <form onSubmit={handleSubmit} style={{boxShadow: "none", border: "none", padding: "0", margin: "0"}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <DebouncingValidatingField name="eppn" validate={this.validateUser} debounce={1000}>
                            {({ input, meta }) => (
                              <div style={{height: "50px", margin: "0 25px 0 0"}}>
                                <input {...input}
                                  type="text"
                                  placeholder="(e.g. mst3k / mst3k@virginia.edu)"
                                  onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      this.searchUser({eppn: input.value});
                                    }
                                  }}/>
                                <br/>{meta.error && meta.touched && <span style={ERRORSTYLE}>{meta.error}</span>}
                              </div>
                            )}
                            </DebouncingValidatingField>
                            <div style={{height: "50px"}}>
                                <button type="submit" disabled={submitting || pristine}>
                                  Search
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    form.reset();
                                    this.clearSearch();
                                  }}
                                  disabled={submitting || pristine}
                                >
                                  Clear
                                </button>
                            </div>
                      </div>
                </form>
              )} />
        </div>
    </Styles>
    );
  }
}
